import { useLocation, useNavigate } from 'react-router-dom';

interface NavItem {
  path: string;
  icon: string;
  activeIcon: string;
  label: string;
  badge?: number;
}

interface BottomNavProps {
  cartCount?: number;
}

const BottomNav = ({ cartCount = 0 }: BottomNavProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems: NavItem[] = [
    { path: '/', icon: 'ri-home-4-line', activeIcon: 'ri-home-4-fill', label: '首页' },
    { path: '/shop', icon: 'ri-store-2-line', activeIcon: 'ri-store-2-fill', label: '商城' },
    { path: '/cart', icon: 'ri-shopping-cart-line', activeIcon: 'ri-shopping-cart-fill', label: '购物车', badge: cartCount },
    { path: '/mine', icon: 'ri-user-line', activeIcon: 'ri-user-fill', label: '我的' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-100 h-16 max-w-[480px] mx-auto">
      <div className="flex items-center justify-around h-full px-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => { navigate(item.path); window.scrollTo({ top: 0, behavior: 'instant' }); }}
              className="flex flex-col items-center justify-center flex-1 h-full relative cursor-pointer whitespace-nowrap"
            >
              <div className="relative w-6 h-6 flex items-center justify-center">
                <i className={`${isActive ? item.activeIcon : item.icon} text-xl ${isActive ? 'text-rose-500' : 'text-gray-400'}`} />
                {item.badge !== undefined && item.badge > 0 && (
                  <span className="absolute -top-1 -right-2 bg-rose-500 text-white text-xs rounded-full min-w-[16px] h-4 flex items-center justify-center px-1 leading-none">
                    {item.badge > 99 ? '99+' : item.badge}
                  </span>
                )}
              </div>
              <span className={`text-xs mt-1 ${isActive ? 'text-rose-500 font-medium' : 'text-gray-400'}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
